import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "hP1ab5",
    defaultMessage: "No Permissions.",
  },
  description: {
    id: "8wUGQF",
    defaultMessage: "You do not have permissions to access this form.",
  },
});
